import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { axiosInstance } from '../../../@core/auth/jwt/jwtService';

export const getNotifications = createAsyncThunk(
    'notifications/getNotifications',
    async (eventId, thunkAPI) => {
        const response = await axiosInstance.request({
            url: `notifications/events/${eventId}`,
            method: 'get',
        });
        return { data: response.data, headers: response.headers };
    }
);

export const getMoreNotifications = createAsyncThunk(
    'notifications/getMoreNotifications',
    async (args, thunkAPI) => {
        const response = await axiosInstance.request({
            url: `notifications/events/${args.eventId}`,
            headers: { ['x-continuation-token']: args.xContinuation },
            method: 'get',
        });
        return { data: response.data, headers: response.headers };
    }
);

export const setNotifications = createAsyncThunk(
    'notifications/setNotifications',
    async (args) => {
        const { eventId, data } = args
        const response = await axiosInstance.request({
            url: `notifications/events/${eventId}`,
            method: 'post',
            data
        });
        return { data: response };
    }
);

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: {
        notifications: [],
        pendingAdd: false,
        pending: false,
        hasMore: false,
        xContinuation: '',
        totalRows: 0,
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getNotifications.fulfilled, (state, action) => {
                const { data } = action.payload.data;
                state.notifications = data;
                state.xContinuation = action.payload.headers['x-continuation-token']
                state.totalRows = action.payload?.data?.total
                state.hasMore = action.payload?.data?.hasNext
                state.pending = false;
            })
            .addCase(getNotifications.pending, (state, action) => {
                state.pending = true;
            })
            .addCase(getNotifications.rejected, (state, action) => {
                state.pending = false;
            })
            .addCase(setNotifications.fulfilled, (state, action) => {
                state.pendingAdd = false;
            })
            .addCase(setNotifications.pending, (state, action) => {
                state.pendingAdd = true;
            })
            .addCase(setNotifications.rejected, (state, action) => {
                state.pendingAdd = false;
            })
            .addCase(getMoreNotifications.fulfilled, (state, action) => {
                const { data } = action.payload.data;
                state.pending = false;
                state.notifications = [...state.notifications, ...data];
                state.xContinuation = action.payload.headers['x-continuation-token']
                state.totalRows = action.payload?.data?.total
                state.hasMore = action.payload?.data?.hasNext
            })
            .addCase(getMoreNotifications.pending, (state, action) => {
                state.pending = true;
            })
            .addCase(getMoreNotifications.rejected, (state, action) => {
                state.pending = false;
            })
    }
})

export default notificationsSlice.reducer